var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{directives:[{name:"parallax",rawName:"v-parallax"},{name:"lazy-loading",rawName:"v-lazy-loading"}]},[_c('img',{attrs:{"data-src":_vm.url,"src":"","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }